<template>
  <div v-swiper:mySwiper="swiperOption">
    <div class="swiper-wrapper">
      <div
        class="swiper-slide"
        v-for="(teacher, index) in dataList"
        :key="index"
      >
        <router-link
          :to="{ name: 'TeacherDetail', params: { id: teacher.teacherId } }"
          target="_blank"
        >
          <div class="teacher-item">
            <div class="teacher-info">
              <div class="teacher-img">
                <img
                  :src="concatImageUrl(teacher.pic1, 220, 330)"
                  :alt="teacher.tchName"
                  style="width: 100%"
                  v-if="teacher.pic1"
                />
                <img
                  v-else
                  src="../../assets/images/v3/teacher-default.png"
                />
              </div>
              <div class="teacher-name">
                <div class="name">{{ teacher.tchName }}</div>
                <div class="remark">{{ teacher.degree }}</div>
              </div>
            </div>
            <div class="teacher-intro">
              <h5>职务职称</h5>
              <p>{{ teacher.academy }}{{ teacher.position }}</p>
              <h5>教学成果</h5>
              <p>{{ teacher.achievement }}</p>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
export default {
  mixins: [siteMixin],
  props: {
    dataList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data () {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
@import "~swiper/css/swiper.css";
.teacher-item {
  position: relative;
  width: 350px;
  padding: 5px 10px;
  .teacher-info {
    width: 280px;
    margin: 0 auto;
    display: flex;
    align-items: flex-end;
    .teacher-img {
      width: 120px;
      height: 160px;
      img {
        width: 120px;
        height: 160px;
      }
    }
    .teacher-name {
      margin-left: 10px;
      text-align: left;
      .name {
        font-size: 26px;
        color: #666;
      }
      .remark {
        display: block;
        width: 120px;
        background: linear-gradient(to right, #349fee, #7098f9);
        padding: 3px 10px;
        color: #fff;
        font-size: 16px;
        border-radius: 4px;
      }
    }
  }
  .teacher-intro {
    margin: -100px auto 0 auto;
    padding: 120px 20px 20px 20px;
    width: 330px;
    background-color: #f9f9f9;
    border-radius: 4px;
    // box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    h5 {
      position: relative;
      font-size: 16px;
      color: #666;
      padding-left: 20px;
      &:before {
        content: " ";
        position: absolute;
        display: block;
        width: 12px;
        height: 12px;
        background: linear-gradient(to right, #349fee, #7098f9);
        border-radius: 10px;
        left: 0;
        top: 5px;
      }
      &:after {
        content: " ";
        position: absolute;
        display: block;
        width: 6px;
        height: 6px;
        background: #fff;
        border-radius: 10px;
        left: 3px;
        top: 8px;
      }
    }
    p {
      display: block;
      padding: 5px 5px 10px 20px;
      color: #666;
      font-size: 16px;
    }
  }
}
.teacher-info {
  text-align: center;
}
.swiper-button-next,
.swiper-button-prev {
  position: absolute;
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  border-radius: 2px;
  background-color: #fff;
  text-align: center;
  outline: none;
  padding-top: 1px;
  &::after {
    font-size: 12px;
    color: #999;
  }
}
.swiper-button-prev {
  top: 30px;
  left: 282px;
}
.swiper-button-next {
  top: 30px;
  right: 12px;
}
</style>